export default "__VITE_ASSET__BnU_l_ZR__"